require( 'slick-carousel-latest' );

$( () => {
  const postSlider = $( '.blog-inner-slick-slider' );
  if ( postSlider ) {
    const slickOptions = postSlider.attr( 'data-slick' );
    if ( !slickOptions ) return;
    postSlider.slick( JSON.parse( slickOptions ) );
  }
} );